import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App';
// import * as actions from './store/actions';
import { Provider } from 'react-redux';
import configureStore from './store';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import registerServiceWorker from './registerServiceWorker';
// import Toolbar from 'material-ui/Toolbar';

const store = configureStore();

ReactDOM.render(
    <MuiThemeProvider>
        <Provider store={store}>
            <App />
        </Provider>
    </MuiThemeProvider>,
    document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js